import React, { memo } from 'react';

import { SequenceStepSelectorProps } from '../../../type';
import SequenceStepSelector from './sequence-selection-step';

const SequenceStepSelectorContainer: React.FC<SequenceStepSelectorProps> = ({
  handleModalClose,
  saveCurrentStepDetails,
}) => (
  <SequenceStepSelector
    handleModalClose={handleModalClose}
    saveCurrentStepDetails={saveCurrentStepDetails}
  />
);

export default memo(SequenceStepSelectorContainer);
